(() => {
  const dialog = document.getElementById('ge-returns-dialog');
  if (!dialog) return;
  let opener;
  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-ge-profile][open]').forEach(profile => {
      if (!profile.contains(event.target)) profile.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || dialog.open) return;
    document.querySelectorAll('[data-ge-profile][open]').forEach(profile => {
      profile.open = false;
      profile.querySelector('summary').focus();
    });
  });
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-ge-returns-open]');
    if (trigger) {
      if (typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      const profile = trigger.closest('[data-ge-profile]');
      opener = profile ? profile.querySelector('summary') : trigger;
      if (profile) profile.open = false;
      if (!dialog.open) dialog.showModal();
    }
    if (event.target.closest('[data-ge-returns-close]')) dialog.close();
    if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
  });
  dialog.addEventListener('close', () => { if (opener) opener.focus(); });
})();
